<div class="grid place-items-center h-[100vh]">
    <div>
        <h1 style="color: #124B99;">404 Error Page</h1>
        <section class="error-container">
            <span class="four"><span class="screen-reader-text">4</span></span>
            <span class="zero"><span class="screen-reader-text">0</span></span>
            <span class="four"><span class="screen-reader-text">4</span></span>
        </section>
      <h1 style="color: #124B99;">Page Not Found</h1>
    </div>
</div>
